import { Injectable, signal } from '@angular/core';

import { ContentSectionTheme } from './content-section.model';

/**
 * When injecting this service, it will provide information about the parent ContentSectionComponent.
 *
 * @example
 * ```
 * <wl-content-section theme="accent-1">
 *
 *   <wl-goat />  <-- when injecting the service here, the theme signal will return "accent-1"
 *
 * </wl-content-section>
 * ```
 */
@Injectable()
export class ContentSectionService {
  /**
   * This will be undefined for components that are not wrapped in a <wl-content-section>
   */
  readonly theme = signal<ContentSectionTheme>(undefined);
}
